export enum ContentType {
	Page = 'page',
	Blogpost = 'blogpost',
	LivePage = 'live-page',
	Whiteboard = 'whiteboard',
	Database = 'database',
	Embed = 'embed',
	Folder = 'folder',
	Slide = 'slide',
}

export interface ContentByLabelItem {
	id: string;
	title: string;
	type: ContentType;
	url: string;
	space: {
		id: string;
		key: string;
		name: string;
	};
	excerpt: string;
	mediaToken: string;
	labels: Array<{
		name: string;
	}>;
}

export interface ContentByLabelResult {
	items: ContentByLabelItem[];
}
